import React from 'react';

import { Base } from '../Base/Base';

import * as S from './Page.styles';

export const Page = ({ aside, bottom, children, description, header, title }) => {
  const hasAside = Boolean(aside);
  const hasBottom = Boolean(bottom);
  const hasDescription = Boolean(description);
  const hasHeader = Boolean(header);
  const hasTitle = Boolean(title);

  return (
    <S.Container hasBottom={hasBottom}>
      {(hasDescription || hasHeader || hasTitle) && (
        <S.Wrapper hasAside={hasAside}>
          <Base description={description} header={header} title={title} />
        </S.Wrapper>
      )}
      <S.Wrapper hasAside={hasAside}>
        <S.Content>{children}</S.Content>
        {hasAside && <S.Aside>{aside}</S.Aside>}
      </S.Wrapper>
      {hasBottom && (
        <S.Wrapper hasAside={hasAside} isBottom>
          {bottom}
        </S.Wrapper>
      )}
    </S.Container>
  );
};
